import "../assets/css/toast-notification.css";
import SuccessImg from "../assets/images/success.svg";
import CloseImg from "../assets/images/close.svg";

function ToastNotification(props) {
    return (
        <div className="toast">
            <button onClick={props.close}  className="close"><img src={CloseImg} alt="Close" /></button>
            <div className="status-icon"><img src={SuccessImg} alt="Success" /></div>
            <div className="body">
                <div className="title">{props.title}</div>
                <div className="subtitle">{props.subtitle}</div>
            </div>
        </div>
    );
}

export default ToastNotification;
